import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 18,
	viewBox: "0 0 10 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_272_2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.501953 9.03516L0.5 9.03418L0.500977 9.0332L0.5 9.03223H0.501953L5.0039 3.93061e-07L9.5 0L5.04785 9.03125L9.4834 18H5.00781L0.501953 9.03516Z",
			fill: "#001E50"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_272_2",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 9,
			height: 18,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgArrowLeft;
